import React, { useState, useContext } from "react";
import classNames from "classnames";
import PageDataContext from "~context/PageDataContext";
import VideoPlayer from "~components/VideoPlayer";
import { SVG_LIBRARY } from "~components/Svg";
import { getCookie } from "~utils";

const PureButton = ({
  theme,
  variant,
  size,
  disabled,
  href,
  icon,
  onClick,
  onMouseOver,
  onMouseLeave,
  type,
  children,
  label = "",
  className = "",
  id = "",
  iconType = "",
}) => {
  const pageContext = useContext(PageDataContext);
  const onClickHandler = (e) => {
    if (window.onvoOfficialWebsiteSensorsDataInstance && pageContext) {
      const accountId = getCookie("onvo-s-id");
      window.onvoOfficialWebsiteSensorsDataInstance.track("WebPageClick", {
        requirement_id: 1283,
        track_sign: "aALPSWeb.b3590.click.WebPageClick",
        page: pageContext.pageData?.meta?.title,
        button_name: label,
        page_type: pageContext.meta?.isDesktop ? "web" : "h5",
        ...(accountId ? { account_id: accountId } : {}),
      });
    }
    onClick && onClick(e);
  };
  if (href || type === "link") {
    return (
      <a
        id={id}
        className={classNames(["button", theme, variant, size, className], {
          disabled: disabled,
        })}
        href={href}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClickHandler}
      >
        {label}
        {children}
        {icon && iconType === "embed" && SVG_LIBRARY[icon]}
      </a>
    );
  } else if (children || label || icon) {
    return (
      <button
        id={id}
        className={classNames(["button", theme, variant, size, className], {
          disabled: disabled,
        })}
        onClick={onClickHandler}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
      >
        {icon && iconType === "" && <img alt={label} src={icon} />}
        {icon && iconType === "embed" && SVG_LIBRARY[icon]}
        {label}
        {children}
      </button>
    );
  }
  return <></>;
};

const Button = (props) => {
  const { video, type, active = true } = props;
  if (!active) {
    return <></>;
  }
  if (type === "video") {
    const [play, setPlay] = useState(false);
    const togglePlay = () => {
      setPlay(!play);
    };
    return (
      <>
        <PureButton {...props} onClick={togglePlay} />
        <VideoPlayer video={video} onClose={togglePlay} play={play} />
      </>
    );
  }
  return <PureButton {...props} />;
};

export default Button;
